import { T車輌写真 } from "../../../service/truck/TSyaryo"

/**
 * 添付ファイル
 */
export type TPictureFile = T車輌写真 &
  Partial<{
    row_id?: string
  }>

/**
 * 車輌写真一覧 型定義
 */
export type TPictureTable = {
  車輌写真リスト: TPictureFile[]
}

/**
 * 車輌写真一覧 初期値
 */
export const initialPictureTableState: TPictureTable = {
  車輌写真リスト: [],
}
